/**
 * Related products section: carousel prev/next and scroll sync.
 */
(function () {
  function initRelatedProductsCarousel() {
    const section = document.querySelector('.shopify-section--related-products');
    if (!section) return;

    const carousel = section.querySelector('scroll-carousel');
    const nextBtn = section.querySelector('[data-action="scroll-next"]');
    const prevBtn = section.querySelector('[data-action="scroll-prev"]');

    if (!carousel || !nextBtn || !prevBtn) {
      setTimeout(initRelatedProductsCarousel, 200);
      return;
    }

    if (nextBtn.hasAttribute('data-initialized')) return;
    nextBtn.setAttribute('data-initialized', 'true');
    prevBtn.setAttribute('data-initialized', 'true');

    function updateButtons() {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const currentScroll = carousel.scrollLeft;
      prevBtn.disabled = currentScroll <= 5;
      nextBtn.disabled = currentScroll >= maxScroll - 5;
    }

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const scrollAmount = carousel.clientWidth * 0.85;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const newScroll = Math.min(carousel.scrollLeft + scrollAmount, maxScroll);
      carousel.scrollTo({ left: newScroll, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const scrollAmount = carousel.clientWidth * 0.85;
      const newScroll = Math.max(carousel.scrollLeft - scrollAmount, 0);
      carousel.scrollTo({ left: newScroll, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });

    carousel.addEventListener('scroll', updateButtons);
    setTimeout(updateButtons, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initRelatedProductsCarousel, 100);
      setTimeout(initRelatedProductsCarousel, 500);
      setTimeout(initRelatedProductsCarousel, 1500);
    });
  } else {
    setTimeout(initRelatedProductsCarousel, 100);
    setTimeout(initRelatedProductsCarousel, 500);
    setTimeout(initRelatedProductsCarousel, 1500);
  }

  const observer = new MutationObserver(function () {
    initRelatedProductsCarousel();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
